import type { Signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { EmailNotificationPreference } from '../../models/email-notification.model';
import {
  LoadEmailNotificationPreference,
  ResetEmailNotificationState,
  UpdateEmailNotification,
} from '../actions';
import { EmailNotificationSelectors } from '../selectors/email-notification.selector';

@Injectable({ providedIn: 'root' })
export class EmailNotificationStoreService {
  private store = inject(Store);

  get managePreferencesEmailNotification(): Signal<
    EmailNotificationPreference[]
  > {
    return this.store.selectSignal(
      EmailNotificationSelectors.managePreferencesEmailNotification,
    );
  }

  get isLoading(): Signal<boolean> {
    return this.store.selectSignal(EmailNotificationSelectors.isLoading);
  }

  get loadError(): Signal<string | null> {
    return this.store.selectSignal(EmailNotificationSelectors.loadError);
  }

  get isUpdating(): Signal<boolean> {
    return this.store.selectSignal(EmailNotificationSelectors.isUpdating);
  }

  get updateError(): Signal<string | null> {
    return this.store.selectSignal(EmailNotificationSelectors.updateError);
  }

  @Dispatch()
  loadEmailNotificationPreference = () => new LoadEmailNotificationPreference();

  @Dispatch()
  resetEmailNotificationState = () => new ResetEmailNotificationState();

  @Dispatch()
  updateEmailNotificationPreference = (
    notifications: EmailNotificationPreference[],
  ) => new UpdateEmailNotification(notifications);
}
